<template lang="pug">
.container.grid-lg.my-2.py-2
  fieldset(:disabled="loading")
    form(@submit.prevent="save")
      .panel
        .panel-header
          .h5 Nova OS
        .panel-body.columns
          form-group.column.col-12(
            :label="'ordem_servico.assunto' | tModel",
            :validation="$v.form.assunto_id"
          )
            assunto-picker(
              v-model="$v.form.assunto_id.$model",
              @selected="onSelectedAssunto"
            )
          form-group.column.col-12(
            :label="'ordem_servico.situacao' | tModel",
            :validation="$v.form.situacao"
          )
            select-ordem-servico-situacao(
              v-model="$v.form.situacao.$model",
              :situacoes="allowedSituacoes"
            )
          form-group.column.col-12(
            :label="'ordem_servico.usuario_responsavel' | tModel",
            :validation="$v.form.usuario_responsavel_id"
          )
            fiscal-picker(v-model="$v.form.usuario_responsavel_id.$model")
          form-group.column.col-12(
            :label="'ordem_servico.analista' | tModel",
            :validation="$v.form.analista_id",
            v-if="assunto && assunto.permite_analise"
          )
            fiscal-picker(v-model="$v.form.analista_id.$model")
          form-group.column.col-12(
            label="Vincular documento",
            :validation="$v.form.notificacao_id"
          )
            doc-picker(v-model="docId", @selected="onSelectedDoc")
          form-group.column.col-12(
            :label="'ordem_servico.cadastro' | tModel",
            :validation="$v.form.cadastro_id"
          )
            cadastro-picker(v-model="$v.form.cadastro_id.$model" @selected="v => cadastro = v")
            div(v-if="cadastro")
              small(v-if="cadastro.endereco") {{ cadastro | deepKey('endereco.formatado') }}
              div(v-if="(!cadastro.endereco || !cadastro.endereco.latitude || !cadastro.endereco.longitude) && !form.endereco")
                .text-warning O endereço do cadastro não possui as coordenadas geográficas
                .text-warning - #[a.c-hand(@click="onPressAddressPickerOpen") Clique aqui] para completar
          address-picker(@selected="onEnderecoSelected" ref="addressPicker" noAddressText="Informar um endereço diferente do cadastro")
          form-group.column.col-3.col-sm-12(
            :label="'ordem_servico.protocolo_tipo' | tModel",
            :validation="$v.form.protocolo_tipo"
          )
            select-protocolo-tipo(v-model="$v.form.protocolo_tipo.$model")
          form-group.column.col-3.col-sm-12(
            v-if="form.protocolo_tipo === 'sei'",
            :label="'ordem_servico.protocolo_numero' | tModel",
            :validation="$v.form.protocolo_numero"
          )
            the-mask.form-input(
              v-model="$v.form.protocolo_numero.$model",
              type="tel",
              mask="##.##.########/####.##",
              :masked="true"
            )
          form-group.column.col-3.col-sm-12(
            v-else,
            :label="'ordem_servico.protocolo_numero' | tModel",
            :validation="$v.form.protocolo_numero"
          )
            input.form-input(v-model="$v.form.protocolo_numero.$model")
          form-group.column.col-3.col-sm-12(
            :disabled="form.protocolo_tipo === 'sei'",
            :label="'ordem_servico.protocolo_ano' | tModel",
            :validation="$v.form.protocolo_ano"
          )
            year.form-input(v-model="$v.form.protocolo_ano.$model")
          form-group.column.col-3.col-sm-12(
            :label="'ordem_servico.protocolo_data' | tModel",
            :validation="$v.form.protocolo_data"
          )
            datepicker(v-model="$v.form.protocolo_data.$model")
          form-group.column.col-3.col-sm-12(
            :label="'ordem_servico.prazo' | tModel",
            :validation="$v.form.prazo"
          )
            int.form-input(v-model="$v.form.prazo.$model")
          form-group.column.col-12(:validation="$v.form.agendar")
            label.form-switch
              input(type="checkbox", v-model="$v.form.agendar.$model")
              i.form-icon
              | É necessário agendar
          .column.col-12.divider.text-center
          form-group.column.col-12(
            :label="'ordem_servico_info.obs' | tModel",
            :validation="$v.form.info.obs"
          )
            textarea.form-input(v-model="$v.form.info.obs.$model", rows="4")
        .panel-body
          checklist-extra(
            v-model="form.info.checklist_extra",
            :assunto="assunto"
          )
          .divider
        .panel-footer.text-right
          button.btn.btn-primary(:disabled="$v.$invalid", :class="loading") Salvar
</template>

<script>
import { deepKey } from "paliari-js-utils"
import { required, maxLength } from "vuelidate/lib/validators"
import toastErrors from "@/lib/errors/toastErrors"
import ChecklistExtra from "./ChecklistExtra"
import AddressPicker from "@/views/osm/servicos/create/components/AddressPicker.vue"

export default {
  vuex: {
    servicos: {
      getters: ["loading"],
      actions: ["fetchCreate"],
    },
  },

  components: { ChecklistExtra, AddressPicker },

  methods: {
    onPressAddressPickerOpen() {
      const parts = []
      const endereco = this.cadastro.endereco || {}
      if (deepKey(endereco, "logradouro.nome")) {
        parts.push(deepKey(endereco, "logradouro.nome"))
      }
      if (deepKey(endereco, "numero")) {
        parts.push(deepKey(endereco, "numero"))
      }
      if (deepKey(endereco, "bairro.nome")) {
        parts.push(deepKey(endereco, "bairro.nome"))
      }
      if (deepKey(endereco, "cidade.nome")) {
        parts.push(
          `${deepKey(endereco, "cidade.nome")} - ${deepKey(
            endereco,
            "cidade.uf",
          )}`,
        )
      }
      this.$refs.addressPicker.open(parts.join(", "))
    },
    async save() {
      try {
        const params = { ...this.form, doc_origem_id: this.docId }
        const { id } = await this.fetchCreate(params)
        this.$toaster.success("OS gerada com sucesso")
        this.$router.replace({ name: "app.osm.servicos.show", params: { id } })
      } catch (e) {
        toastErrors(e)
      }
    },
    onSelectedDoc(doc) {
      if (doc) this.$set(this.form, "cadastro_id", deepKey(doc, "cadastro.id"))
    },
    onSelectedAssunto(assunto) {
      this.$set(this, "assunto", assunto)
      this.$set(this.form, "prazo", deepKey(assunto, "prazo") || 0)
    },
    onEnderecoSelected(endereco) {
      this.form.endereco = endereco
    },
  },
  data() {
    return {
      assunto: null,
      form: {
        assunto_id: null,
        situacao: null,
        notificacao_id: null,
        cadastro_id: null,
        usuario_responsavel_id: null,
        analista_id: null,
        protocolo_tipo: "geral",
        protocolo_numero: null,
        protocolo_ano: 0,
        protocolo_data: "",
        agendar: false,
        doc_origem_id: null,
        endereco: null,
        info: { obs: "" },
        prazo: 0,
      },
      cadastro: null,
      allowedSituacoes: {
        abertura: "Em Abertura",
        andamento: "Em andamento",
        em_distribuicao: "Em distribuição",
        aguardando_distribuir: "Aguardando Distribuir",
      },
      docId: null,
    }
  },
  validations() {
    const validations = {
      form: {
        assunto_id: { required },
        situacao: {},
        notificacao_id: {},
        cadastro_id: { required },
        agendar: {},
        usuario_responsavel_id: {},
        endereco: {},
        analista_id: {},
        protocolo_tipo: {},
        protocolo_numero: {},
        protocolo_ano: {},
        protocolo_data: {},
        info: { obs: { maxLength: maxLength(4000) } },
        prazo: {},
      },
    }
    if (this.form.situacao === "em_distribuicao") {
      validations.form.usuario_responsavel_id = { required }
    }
    if (this.assunto && this.assunto.exige_analise) {
      validations.form.analista_id = { required }
    }
    return validations
  },
  created() {
    const { cadastro_id } = this.$route.query
    const { assunto, cadastro, form } = this.$route.params || {}

    if (cadastro_id) {
      this.form.cadastro_id = cadastro_id
    }

    if (form && assunto && cadastro) {
      this.form = form
      this.assunto = assunto
      this.cadastro = cadastro
    }
  },
}
</script>
